enum RobotStatus {
    Unresponsive = 0,
    Online = 1,
    Busy = 2
}

const RobotStatusValue = {
    GetText: (typeNumber: number) => {
        return RobotStatus[typeNumber].valueOf()
    }
}

export default RobotStatusValue